export const validateDocuments = (documents) => {
  if (!documents) return null;
  for (const value of Object.values(documents)) {
    const status = typeof value === "object" ? value.status : value;
    if (status === "Required") {
      return "Required documents are missing";
    }
  }
  return null;
};

/**
 * Validates a single document field.
 * @param {string} name - Document name
 * @param {string} status - Upload status
 * @returns {string|null} - Error message or null if valid
 */
export const validateDocumentField = (name, status) => {
  if (status === "Required") {
    return `${name} is required`;
  }
  return null;
};
